export default __webpack_public_path__ + "static/media/Subtraction_02.ac29afdf.png";